import * as types from '../constants/ActionTypes.js'
import * as status from '../constants/Status'
import { POSTYPE_NORMAL, DISPLAYMODE_CLASSIC } from '../constants/Types'

const initGeneralState = {
  uniqueid: null,
  licensestatus: true,
  datetime: new Date(),
  posId: 0,
  posDescription: 'Kies omgeving',
  posType: POSTYPE_NORMAL,
  printReceiptInfo: false,
  previousReceiptId: -1,
  isLoading: false,
  paymentMethod: {
    all: [],
    selectedid: 0,
    selecteddescription: ''
  },
  countries: [],
  customergroups: [],
  labels: {
    all: [],
    posLabels: []
  },
  discountMenuArticleID: 0,
  discountMenuArticleIDList: [],
  roundAmount: false,
  devices: [],
  posList: [],
  storeList: [],
  companyList: [],
  languages: null,
  configurationsteps: [],
  articles: [],
  pricelists: [],
  defaultPricelistId: 0,
  graphicDisplay: false,
  useConfigurations: true,
  allowEmptyPrice: true,
  openingTime: null,
  closingTime: null,
  hasBlackbox: true,
  systemSettings: {},
  displayMode: DISPLAYMODE_CLASSIC,
  modal: {
    messageModal: {
      show: false,
      message: 'default'
    },
    selectModal: {
      listvalues: [],
      show: false,
      message: 'default',
      callback: null,
      callbackparams: []
    },
    splashModal: {
      show: false,
      message: 'default',
      retry: false
    },
    confirmModal: {
      show: false,
      message: '',
      confirm: null,
      cancel: null,
      confirmparam: null,
      cancelparam: null,
      dispatch: null
    },
    configurationModal: {
      show: false,
      description: '',
      configurationSteps: [],
      selecteditem: null
    }
  },
  licenses: {
    blackbox: false,
    blackboxReceiptId: 0
  },
  blackboxstatus: { ErrorCode: -1, ErrorMessage: '' },
  keyfunctionexecuted: 0,
  resetTime: 0,
  version: '0.0.0',
  tempRights: -1,
  hasFiscalPrinter: false,
  usePager: false,
}

export const generalReducer = function init(state = initGeneralState, action) {
  switch (action.type) {
    case types.CLEAR_STATE:
      return initGeneralState;
    case types.DUMMY_CHECK_LICENSE:
      return Object.assign({}, state, { licensestatus: action.licensestatus })
    case types.SET_LICENSE_STATUS:
      return Object.assign({}, state, { licensestatus: action.status })
    case types.SET_DATETIME:
      return Object.assign({}, state, { datetime: action.datetime })
    case types.CLEAR_POS:
      return Object.assign({}, state, { posId: initGeneralState.posId, posDescription: initGeneralState.posDescription, posType: initGeneralState.posType, printReceiptInfo: initGeneralState.printReceiptInfo, displayMode: initGeneralState.displayMode, resetTime: initGeneralState.resetTime, useConfigurations: initGeneralState.useConfigurations, allowEmptyPrice: initGeneralState.allowEmptyPrice, openingTime: initGeneralState.openingTime, closingTime: initGeneralState.closingTime, usePager: initGeneralState.usePager, hasBlackbox: initGeneralState.hasBlackbox })
    case types.SET_POS:
      return Object.assign({}, state, { posId: action.pos, posDescription: action.description, posType: action.postype, printReceiptInfo: action.printReceiptInfo, displayMode: action.displayMode, resetTime: action.resetTime, useConfigurations: action.useConfigurations, allowEmptyPrice: action.allowEmptyPrice, openingTime: action.openingTime, closingTime: action.closingTime, usePager: action.usePager, hasBlackbox: action.hasBlackbox })
    case types.LOADING_START:
      return Object.assign({}, state, { isLoading: true })
    case types.LOADING_END:
      return Object.assign({}, state, { isLoading: false })
    case types.SET_PREVIOUS_RECEIPT_ID:
      return Object.assign({}, state, { previousReceiptId: action.id })
      case types.SET_HAS_FISCALPRINTER:
        return Object.assign({}, state, { hasFiscalPrinter: action.hasFiscalPrinter })
    case types.SET_MESSAGE_MODAL:
      return Object.assign({}, state, {
        modal: {
          messageModal: {
            show: action.show,
            message: action.message
          },
          selectModal: state.modal.selectModal,
          splashModal: state.modal.splashModal,
          confirmModal: state.modal.confirmModal,
          configurationModal: state.modal.configurationModal
        }
      });
    case types.SET_SPLASH_MODAL: 
      return Object.assign({}, state, {
        modal: {
          splashModal: {
            show: action.show,
            message: action.message,
            retry: action.retry
          },
          selectModal: state.modal.selectModal,
          messageModal: state.modal.messageModal,
          confirmModal: state.modal.confirmModal,
          configurationModal: state.modal.configurationModal
        }
      });
    case types.SET_SELECT_MODAL:
      return Object.assign({}, state, {
        modal: {
          selectModal: {
            listvalues: action.listvalues,
            show: action.show,
            message: action.message,
            callback: action.callback,
            callbackparams: action.callbackparams,
            showCancel: action.showCancel,
            dispatch: action.dispatch
          },
          messageModal: state.modal.messageModal,
          splashModal: state.modal.splashModal,
          confirmModal: state.modal.confirmModal,
          configurationModal: state.modal.configurationModal
        }
      });
    case types.SET_CONFIRM_MODAL:
      return Object.assign({}, state, {
        modal: {
          confirmModal: {
            show: action.show,
            message: action.message,
            confirm: action.confirm,
            cancel: action.cancel,
            confirmparam: action.confirmparam,
            cancelparam: action.cancelparam,
            dispatch: action.dispatch
          },
          selectModal: state.modal.selectModal,
          messageModal: state.modal.messageModal,
          splashModal: state.modal.splashModal,
          configurationModal: state.modal.configurationModal
        }
      });
    case types.SET_CONFIGURATION_MODAL:
      return Object.assign({}, state, {
        modal: {
          configurationModal: {
            show: action.show,
            configurationSteps: action.configurationSteps,
            article: action.article,
            lineid: action.lineid
          },
          selectModal: state.modal.selectModal,
          messageModal: state.modal.messageModal,
          splashModal: state.modal.splashModal,
          confirmModal: state.modal.confirmModal
        }
      });
    case types.RECEIVE_PAYMENT_METHODS:
      return Object.assign({}, state, {
        paymentMethod: {
          all: action.paymentMethods,
          selected: 0
        }
      });
    case types.RECEIVE_COUNTRIES:
      return Object.assign({}, state, {
        countries: action.countries
      });
    case types.RECEIVE_CUSTOMERGROUPS:
      return Object.assign({}, state, {
        customergroups: action.customergroups
      });
    case types.RECEIVE_LABELS:
      return Object.assign({}, state, {
        labels: {
          all: action.labels.Labels,
          posLabels: action.labels.PosLabels,
        }
      });
    case types.RECEIVE_SYSTEM_SETTING:
      const newSystemSettings = state.systemSettings ? state.systemSettings : {};
      newSystemSettings[action.settingKey] = action.value.Value;

      return Object.assign({}, state, {
        systemSettings: newSystemSettings
      });
    case types.SET_PAYMENT:
      return Object.assign({}, state, {
        paymentMethod: {
          all: state.paymentMethod.all,
          selectedid: action.paymentMethodId,
          selecteddescription: action.description
        }
      });
    case types.RECEIVE_DEVICES:
      return {
        ...state,
        devices: action.devices.map(device => ({
          deviceid: device.DeviceId,
          description: device.Description,
          devicecontroller: device.DeviceController,
          printertype: device.PrinterType,
          status: status.PRINTER_OK,
          statusmsg: 'In orde',
          posdevicelinkid: device.PosDeviceLinkId,
          devicetype: device.DeviceType
        }))
      };
    case types.PRINTER_UPDATE_STATUS:
      return {
        ...state,
        devices: state.devices.map(device => ({
          deviceid: device.deviceid,
          description: device.description,
          devicecontroller: device.devicecontroller,
          printertype: device.printertype,
          status: (device.deviceid === action.itemid) ? action.status : device.status,
          statusmsg: (device.deviceid === action.itemid) ? action.statusmsg : device.statusmsg,
          posdevicelinkid: device.posdevicelinkid,
          devicetype: device.devicetype
        }))
      };
    case types.RECEIVE_POSLIST:
      return {
        ...state,
        posList: action.json
      };
    case types.RECEIVE_STORELIST:
      return {
        ...state,
        storeList: action.json
      };
    case types.RECEIVE_COMPANYLIST:
      return {
        ...state,
        companyList: action.json
      };
    case types.GET_LICENSES:
      return Object.assign({}, state, {
        licenses: {
          blackbox: action.blackbox,
          blackboxReceiptId: state.licenses.blackboxReceiptId
        }
      });
    case types.GET_BLACKBOX_STATUS:
      return {
        ...state,
        blackboxstatus: action.status
      };
    case types.LIST_CONFIGURATIONS:
      return Object.assign({}, state, {
        configurationsteps: action.steps
      });
    case types.LIST_ARTICLES:
      return Object.assign({}, state, {
        articles: action.articles
      });
    case types.LIST_PRICELIST:
      return Object.assign({}, state, {
        pricelists: action.pricelists
      });
    case types.SET_KEYFUNCTION_EXECUTED:
      return Object.assign({}, state, {
        keyfunctionexecuted: action.functioncode
      });
    case types.SET_VERSION:
      return Object.assign({}, state, {
        version: action.version
      });
    case types.SET_UNIQUEID:
      return Object.assign({}, state, {
        uniqueid: action.uniqueid
      });
    case types.SET_BLACKBOX_RECEIPTID:
      return Object.assign({}, state, {
        licenses: {
          blackbox: state.licenses.blackbox,
          blackboxReceiptId: action.receiptId
        }
      });
    case types.SET_POS_PRICELIST:
      return Object.assign({}, state, {
        defaultPricelistId: action.pricelistid
      });
    case types.SET_POS_DEFAULT_PAYMENT:
      return Object.assign({}, state, {
        defaultChangePaymentId: action.defaultChangePaymentId
      });
    case types.SET_ROUND_AMOUNT:
      return Object.assign({}, state, {
        roundAmount: action.roundAmount
      });
    case types.SET_POS_GRAPHIC_DISPLAY:
      return Object.assign({}, state, {
        graphicDisplay: action.graphicdisplay
      });
    case types.ADD_DISCOUNT_MENU_ARTICLEIDS:
      return Object.assign({}, state, {
        discountMenuArticleIDList: Array.from(new Set([...state.discountMenuArticleIDList, ...action.articleIds]))
      });
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/general.js